import DictInput from './DictInput';

const renderDict = (props) => {
  if (props?.schema?.type !== 'dict') return null;
  return <DictInput {...props} />;
};

export default renderDict;
